var render = function render(){var _vm=this,_c=_vm._self._c;return _c('material-card',{attrs:{"color":"blue","title":"Import your csv file","offset":"10"}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('common-sheets-upload',{attrs:{"post-action":`${_vm.baseURL}/api/v1/import/csv`},on:{"create:upload":_vm.loadList}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }